export const URL_CACHE_NAME = "urlCache";
export const CHANNELS_FAVORITE_ID = 4294967294; // magic int what is save in db

export const TV_TYPE = "TV";
export const CHANNEL_TYPE = "channel";
export const RADIO_TYPE = "radio";
